import 'css-chunksrc/client/pages/workloadPage/toolbar/styles.scss';export default {
  "toolbar": "_toolbar_1tmto_1",
  "filter": "_filter_1tmto_10",
  "title": "_title_1tmto_16"
};